export default {
  default: 'theme-default',
  dark: 'theme-dark',
} as { [key: string]: string };
